import React from 'react';
import ContentLoader from 'react-content-loader';

const PreciousMetalsLoader = () => {
  const totalElem = 3
  const height = 200
  const body = new Array(totalElem + 1).fill(null).map((i, ind) => {
    let yStrip = ind ? (35 * ind + 26) : 54

    return (
      <React.Fragment key={ind}>
        {
          <>
            <rect x="13" y="26" rx="3" ry="3" width="68" height="14" />
            <rect x="98" y="26" rx="3" ry="3" width="23" height="14" />
            <rect x="130" y="26" rx="3" ry="3" width="68" height="14" />
            <rect x="15" y={yStrip} rx="3" ry="3" width="38" height="14" />
            <rect x="64" y={yStrip} rx="3" ry="3" width="50" height="14" />
            <rect x="121" y={yStrip} rx="3" ry="3" width="35" height="14" />

            <rect x="239" y="26" rx="3" ry="3" width="68" height="14" />
            <rect x="324" y="26" rx="3" ry="3" width="23" height="14" />
            <rect x="356" y="26" rx="3" ry="3" width="68" height="14" />
            <rect x="241" y={yStrip} rx="3" ry="3" width="38" height="14" />
            <rect x="290" y={yStrip} rx="3" ry="3" width="50" height="14" />
            <rect x="347" y={yStrip} rx="3" ry="3" width="35" height="14" />

            <rect x="465" y="26" rx="3" ry="3" width="68" height="14" />
            <rect x="550" y="26" rx="3" ry="3" width="25" height="14" />
            <rect x="582" y="26" rx="3" ry="3" width="68" height="14" />
            <rect x="468" y={yStrip} rx="3" ry="3" width="38" height="14" />
            <rect x="518" y={yStrip} rx="3" ry="3" width="50" height="14" />
            <rect x="577" y={yStrip} rx="3" ry="3" width="35" height="14" />

          </>
        }
      </React.Fragment>
    )
  })
  return (
    <ContentLoader
      speed={2}
      width={1458}
      height={height}
      viewBox={`0 0 1458 ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb">
      <>
        {body}
      </>
    </ContentLoader>
  );
};

export default PreciousMetalsLoader;
